import { render, staticRenderFns } from "./renovacao.vue?vue&type=template&id=7fa1244d"
import script from "./renovacao.vue?vue&type=script&lang=js"
export * from "./renovacao.vue?vue&type=script&lang=js"
import style0 from "./renovacao.vue?vue&type=style&index=0&id=7fa1244d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports